import { useMemo } from 'react'
import { useLocation } from 'react-router'

const useCheckLocation = () => {
  const { pathname } = useLocation()
  const pathToCheck = 'my-workspace'

  const isInMyWorkspace = useMemo(() => {
    return pathname.includes(pathToCheck)
  }, [pathname])

  return { isInMyWorkspace }
}

export default useCheckLocation
